<template>
    <div>
        <header-message class="mt-3 mb-3">{{ downloadInfo }}</header-message>
        <header-message v-if="releaseNotes" class="mb-3 desc">
            {{ releaseNotes }}
        </header-message>

        <power-off />
    </div>
</template>

<style lang="scss">
    .desc.status {
        font-size: 1.5rem;
        text-align: left;
        font-style: normal;
    }
</style>

<script lang="ts">

import { defineComponent } from "vue";

import PageBase from "@/shared/components/common/PageBase";
import HeaderMessage from "@/components/HeaderMessage.vue";
import PowerOff from "@/components/PowerOff.vue";
import { Global } from "@/support/GlobalData";

export default defineComponent({
    name: "UpgradeDownload",
    mixins: [PageBase],
    components: {
        HeaderMessage,
        PowerOff,
    },
    data() {
        return {
            timerInterval: 0 as number,
            progress: 0 as number,
        };
    },
    computed: {
        releaseNotes(): string {
            if (!Global.PackageUpgrade) return "";
            return Global.PackageUpgrade?.ReleaseNotes;
        },
        downloadInfo(): string {
            if (!this.progress) return "Downloading Upgrade";
            return `Download in Progress - ${this.progress.toFixed(0)}%`;
        },
    },
    methods: {
        setProgress(): void {
            this.progress = Auggie.PackageDownload.Progress();
            if (Auggie.PackageDownload.IsDone()) {
                this.clearTimerInterval();
                this.$router.push("/Upgrade/Installing");
            } else if (Auggie.PackageDownload.IsAborted()) {
                this.clearTimerInterval();
                this.$router.push("/Upgrade/Failed");
            }
        },
        clearTimerInterval(): void {
            if (this.timerInterval) {
                clearInterval(this.timerInterval);
                this.timerInterval = 0;
            }
        },
    },
    mounted(): void {
        this.timerInterval = setInterval((): void => {
            this.setProgress();
        }, 1500) as unknown as number;
    },
    unmounted(): void {
        this.clearTimerInterval();
    },
});
</script>
